<template>
  <div v-if="hasMultipleRoles" class="role-switcher body">
    <select v-model="selectedRole" @change="switchRole" class="role-select">
      <option v-for="role in availableRoles" :key="role" :value="role">
        {{ t(`roles.${role}`) }}
      </option>
    </select>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  name: 'RoleSwitcher',
  setup() {
    const authStore = useAuthStore()
    const router = useRouter()
    const { t } = useI18n()

    const selectedRole = ref(authStore.getCurrentRole)
    const hasMultipleRoles = computed(() => authStore.hasMultipleRoles)
    const availableRoles = computed(() => authStore.getAvailableRoles)

    watch(() => authStore.getCurrentRole, (newRole) => {
      selectedRole.value = newRole
    })

    const switchRole = async () => {
      authStore.setSelectedRole(selectedRole.value)
      
      if (selectedRole.value === 'operator') {
        const operatorData = authStore.operatorData
        if (!operatorData) {
          console.error('No operator data found')
          return
        }
        const defaultDepartment = operatorData.categories?.[0]?.type || 'support'
        router.push({
          path: '/operator-panel',
          query: {
            department: defaultDepartment,
            companyId: operatorData.company_id,
            companyName: operatorData.company_name
          }
        })
      } else {
        router.push(getRoleDashboard(selectedRole.value))
      }
    }

    const getRoleDashboard = (role) => {
      switch(role) {
        case 'customer': return '/dashboard'
        case 'employer': return '/employer/dashboard'
        case 'store': return '/sales/kala-store'
        case 'admin': return '/admin/dashboard'
        default: return '/dashboard'
      }
    }

    return {
      selectedRole,
      hasMultipleRoles,
      availableRoles,
      switchRole,
      t
    }
  }
}
</script>

<style scoped>
.role-switcher {
  margin-inline-start: 20px; /* RTL friendly */
}

.role-select {
  padding: 8px 12px;
  min-width: 140px;
  font-size: 14px;
  direction: rtl;
  cursor: pointer;
  border-radius: 6px;
  background-color: var(--input-bg);
  color: var(--text);
  transition: var(--transition);
}

.role-select:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--primary-focus-ring);
}

.role-select option {
  text-align: right;
  background: var(--card-bg);
  color: var(--text);
}
</style>
